// import React from 'react';
// import PageTemplate from './PageTemplate';
// export default function ContactUs(props) { return <PageTemplate {...props} slug="Contact_Us" />; }

import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';
import Header from '../Header';
import Footer from '../Footer';

const pb = new PocketBase('https://bahcarplaza.com');

function ContactUs({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    message: ''
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // পকেটবেসে 'contact_leads' কালেকশনে তথ্য সেভ করা
      await pb.collection('contact_leads').create(formData);
      alert("Message sent successfully! Our team will contact you soon.");
      setFormData({ first_name: '', last_name: '', email: '', phone: '', message: '' });
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  const inputStyle = "w-full p-4 rounded-2xl border border-gray-200 focus:border-[#ef5e33] focus:ring-1 focus:ring-[#ef5e33] outline-none font-bold text-sm bg-gray-50 transition-all";

  return (
    <div className="min-h-screen bg-[#f4f7f6] flex flex-col font-sans">
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
      
      <main className="flex-1 pb-20">
        {/* 🚨 HERO BANNER 🚨 */}
        <section className="relative w-full h-[300px] md:h-[450px] overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80" 
            className="w-full h-full object-cover" 
            alt="Banner" 
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#002f34]/90 to-[#002f34]/70 flex flex-col items-center justify-center text-center px-6">
            <h1 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter">
              Get In <span className="text-[#ef5e33]">Touch</span>
            </h1>
            <p className="text-gray-300 font-bold mt-4 max-w-xl">We are here to help you find your dream car or sell your current one with ease.</p>
          </div>
        </section>

        {/* 🚨 MAIN SECTION: LARGE MAP & FORM 🚨 */}
        <section className="max-w-[1450px] mx-auto px-6 -mt-24 relative z-20">
          <div className="flex flex-col lg:flex-row gap-8 items-stretch">
            
            {/* LEFT SIDE: LARGE MAP CARD (65% Width) */}
            <div className="lg:w-[65%] bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-gray-100 flex flex-col">
              <div className="flex-1 min-h-[450px] md:min-h-[600px]">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117921.28583488737!2d88.35824535!3d22.4181188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0271032331589b%3A0x6b779a1170768e82!2sRajpur%20Sonarpur%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1709514000000!5m2!1sen!2sin" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  title="Bah Car Plaza Location"
                ></iframe>
              </div>
              <div className="p-10 bg-gradient-to-r from-white to-[#f9fafb] flex flex-col md:flex-row justify-between items-center gap-6">
                <div>
                  <h2 className="text-2xl font-black text-[#002f34] mb-3 border-l-8 border-[#ef5e33] pl-4 uppercase tracking-widest">Corporate Headquarters</h2>
                  <p className="text-gray-500 font-bold text-lg leading-relaxed">
                    Bah! Car Plaza Services Private Limited, <br/>
                    Rajpur Sonarpur, Kolkata, West Bengal 700150.
                  </p>
                </div>
                <div className="flex gap-4">
                  <button onClick={() => window.open('https://maps.google.com', '_blank')} className="bg-[#002f34] text-white px-6 py-3 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-[#ef5e33] transition-colors shadow-lg">Get Directions</button>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE: COMPACT CONTACT FORM (35% Width) */}
            <div className="lg:w-[35%] bg-white rounded-[2.5rem] shadow-2xl p-8 md:p-12 border border-gray-100 flex flex-col justify-center relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#ef5e33]/5 rounded-full -mr-16 -mt-16"></div>
              
              <div className="relative z-10">
                <h2 className="text-3xl font-black text-[#002f34] mb-2 uppercase tracking-tighter">Drop us a <span className="text-[#ef5e33]">Message</span></h2>
                <p className="text-gray-400 font-bold text-[10px] mb-10 uppercase tracking-[0.2em]">We typically reply within 24 hours</p>
                
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    <div>
                      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 block ml-1">First Name</label>
                      <input required type="text" value={formData.first_name} className={inputStyle} onChange={e => setFormData({...formData, first_name: e.target.value})} />
                    </div>
                    <div>
                      <label className="text-[10px] font-black text-gray-400 uppercase mb-2 block ml-1">Last Name</label>
                      <input required type="text" value={formData.last_name} className={inputStyle} onChange={e => setFormData({...formData, last_name: e.target.value})} />
                    </div>
                  </div>

                  <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase mb-2 block ml-1">Business Email</label>
                    <input required type="email" value={formData.email} className={inputStyle} onChange={e => setFormData({...formData, email: e.target.value})} />
                  </div>

                  <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase mb-2 block ml-1">Phone Number</label>
                    <input required type="number" value={formData.phone} className={inputStyle} onChange={e => setFormData({...formData, phone: e.target.value})} />
                  </div>

                  <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase mb-2 block ml-1">Your Message</label>
                    <textarea required rows="3" value={formData.message} className={`${inputStyle} resize-none`} onChange={e => setFormData({...formData, message: e.target.value})}></textarea>
                  </div>

                  <button type="submit" className="w-full py-5 bg-[#ef5e33] text-white font-black rounded-2xl uppercase tracking-[0.15em] hover:bg-[#002f34] transition-all duration-500 shadow-xl flex items-center justify-center gap-3 group mt-4">
                    Send Message
                    <span className="group-hover:translate-x-2 transition-transform duration-300 text-xl">→</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* 🚨 BOTTOM CONTACT CARDS 🚨 */}
        <section className="max-w-[1400px] mx-auto px-6 mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: '🎧', title: 'Customer Support', email: 'bahcarplaza@gmail.com' },
            { icon: '🤝', title: 'Partnership', email: 'bahcarplaza@gmail.com' },
            { icon: '📰', title: 'Media Queries', email: 'bahcarplaza@gmail.com' },
            { icon: '🛡️', title: 'Whistle Blower', email: 'bahcarplaza@gmail.com' }
          ].map((item, idx) => (
            <div key={idx} className="bg-white p-8 rounded-[2rem] border border-gray-100 text-center hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group">
              <div className="w-14 h-14 bg-[#f4f7f6] rounded-2xl flex items-center justify-center text-2xl mb-5 mx-auto group-hover:bg-[#ef5e33] group-hover:text-white transition-colors">
                {item.icon}
              </div>
              <h3 className="font-black text-[#002f34] text-xs uppercase tracking-widest mb-2">{item.title}</h3>
              <p className="text-gray-500 text-[11px] mb-6 font-bold">{item.email}</p>
              <a href={`mailto:${item.email}`} className="inline-block w-full py-3 border-2 border-gray-100 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-[#002f34] hover:text-white hover:border-[#002f34] transition-all">Email Us</a>
            </div>
          ))}
        </section>

        {/* WhatsApp Floating Button Style */}
        <div className="mt-20 text-center">
          <button 
            onClick={() => window.open('https://wa.me/916289913919', '_blank')}
            className="inline-flex items-center gap-3 border-[3px] border-[#25D366] text-[#25D366] px-10 py-4 rounded-2xl font-black uppercase tracking-widest hover:bg-[#25D366] hover:text-white transition-all duration-300 shadow-2xl"
          >
            <span>Chat on Whatsapp</span>
            <span className="text-2xl">💬</span>
          </button>
        </div>
      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default ContactUs;